const VIPRedemptionStatus = {
  Pending: "pending",
  Success: "success",
  Failed: "failed",
};

export default VIPRedemptionStatus;
